<template>
  <div
    class="modal-task start-task-wrapper"
    :class="{ 'workflow-model-scroll': task.props.trigger == 'formTrigger' }"
  >
    <div class="modal-backdrop"></div>
    <div class="modal task">
      <div class="modal-close" @click="close"></div>
      <div v-if="!loading" class="content">
        <h1 v-if="task.props.trigger == 'timeTrigger'">Workflow Auflöser</h1>
        <div v-show="task.props.trigger == 'formTrigger'" class="tab tab-form">
          <div class="header">
            <div class="tools">
              <div
                class="round-button item"
                @click="showAskAiUiModal()"
                v-b-tooltip.hover.top
                title="Mit KI formatieren"
              >
                <i class="fa fa-magic"></i>
              </div>
              <div
                class="round-button item preview"
                :disabled="!isUserHasAccess"
                v-b-tooltip.hover.top
                title="Vorschau"
                @click="toggleFormPreview(true)"
              >
                <div>
                  <img
                    src="../../assets/img/work-flow-icons/preview-without-border.svg"
                    alt=""
                  />
                </div>
              </div>
              <div
                class="round-button item daten-bank-schema"
                :disabled="!isUserHasAccess"
                @click="toggleDatabaseSchemaModal(true)"
                v-b-tooltip.hover.top
                title="Datenbankschema"
              >
                <img src="../../assets/img/database-schema-copy.svg" alt="" />
              </div>
              <div
                class="round-button item"
                v-if="task?.name == 'Start'"
                :disabled="!isUserHasAccess"
                @click="showFlowReferenceModal()"
                v-b-tooltip.hover.bottom
                title="Einstellungen"
              >
                <i class="fa fa-cog"></i>
              </div>
              <div
                class="round-button item options"
                :disabled="!isUserHasAccess"
                v-b-tooltip.hover.right
                title="weitere Funktionen"
              >
                <generalDropdown
                  :disabled="!isUserHasAccess"
                  className="filter-dropdown"
                  :isCaretVisible="false"
                >
                  <template v-slot:selectFilter>
                    <span class="line-clamp">
                      <i class="fas fa-ellipsis-h"></i>
                    </span>
                  </template>
                  <template v-slot:optionData>
                    <b-dropdown-item
                      v-for="(option, index) in getDropDownItems"
                      :key="option.label"
                    >
                      <div
                        class="extra-options-wrapper"
                        @click="option.clickTrigger"
                      >
                        <i :class="option.icon"></i>
                        <span>{{ option.label }}</span>
                      </div>
                    </b-dropdown-item>
                  </template>
                </generalDropdown>
              </div>
              <div
                v-if="false"
                class="round-button item"
                @click="showFlowAuthModal()"
              >
                <i class="far fa-user"></i>
              </div>
            </div>
          </div>
          <div class="form-container">
            <form
              :class="{ 'full-width': settings.fullWidth }"
              class="initial-form"
            >
              <div class="form-header">
                <!-- <input
                  class="title"
                  v-model="task.props.formTrigger.title"
                  contenteditable="true"
                  placeholder="Title eingeben..."
                />
                <input
                  v-show="false"
                  class="description"
                  v-model="task.props.formTrigger.description"
                  contenteditable="true"
                  placeholder="Beschreibung eingeben..."
                /> -->
              </div>
              <FormBuilder
                :isAskAiUiModalVisible="isAskAiUiModalVisible"
                :flowRunnerEndpoint="flowRunnerEndpoint"
                class="start-form-builder"
                :elements="elements"
                :structure="structure"
                :isFullWidth="settings.fullWidth"
                :formulaVersion="getformulaVersion"
                :isHtmlElementVisible="settings.isHtmlElementVisible"
                :isEditable="true"
                :isContentEditable="true"
                :isUserHasAccess="isUserHasAccess"
                :elementInputs="task.input"
                :elementsToHide="getElementsToHide"
                :taskName="task.name"
                @saveElements="saveElements"
                @saveStructure="saveStructure"
                @addUiInUiElement="addUiInUiElement"
                @showAskAiUiModal="showAskAiUiModal"
                @toggleAiDropdown="toggleAiDropdown"
              />
            </form>
          </div>
        </div>
      </div>
      <div v-else class="loading-spinner">
        <LoadingSpinner :loadingCaption="'wird gespeichert...'" />
      </div>
      <flowAuthModal
        @close="hideFlowAuthModal()"
        @save="saveFlowSettings()"
        :flowSettings="this.settings"
        v-show="isFlowAuthModalVisible"
      ></flowAuthModal>
      <flowReferenceModal
        @close="hideFlowReferenceModal()"
        @save="saveFlowSettings()"
        @setShowResultInForm="$emit('setShowResultInForm', $event)"
        :flowSettings="this.settings"
        :task="this.task"
        :process="this.process"
        :isAdmin="this.isAdmin"
        :showDatabaseMissing="showDatabaseMissing"
        :isUserHasAccess="isUserHasAccess"
        :databases="getCustomDatabases"
        :isTableIdArray="isTableIdArray"
        :getSelectedDbList="getSelectedDbList"
        v-if="isFlowReferenceModalVisible"
      ></flowReferenceModal>
      <askAiUiModal
        :flowRunnerEndpoint="flowRunnerEndpoint"
        v-if="isAskAiUiModalVisible"
        @close="hideAskAiUiModal()"
        @addUiInUiElement="addUiInUiElement"
        :elements="elements"
        @removeAiCss="removeAiCss"
        :isAiDropdownVisible="isAiDropdownVisible"
      >
      </askAiUiModal>
      <DatabaseSchemaSelect
        v-if="copyDatabaseSchemaIntoWorkflow.showDatabaseSchemaModal"
        @close="toggleDatabaseSchemaModal"
        @save="addSchemaIntoWorkflow"
      >
      </DatabaseSchemaSelect>

      <!-- preivew wrapper -->
      <div
        class="preview-wrapper"
        v-if="formPreviewBlobURL || isPreviewLoading"
      >
        <div class="loading-container" v-if="isPreviewLoading">
          <LoadingSpinner
            loadingCaption="Vorschau wird geladen..."
            v-show="isPreviewLoading"
          />
        </div>
        <div v-if="formPreviewBlobURL" :class="{ hide: isPreviewLoading }">
          <PagePreviewModal
            @onClose="toggleFormPreview"
            @onPreviewLoad="onPreviewLoad"
            :url="formPreviewBlobURL"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flowReferenceModal from '../modals/flowReferenceModal.vue';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import flowAuthModal from '../modals/flowAuthModal.vue';
import fileKeySelect from '../modals/fileKeySelect.vue';
import FormBuilder from '../widgets/FormBuilderV2.vue';
import askAiUiModal from '../modals/askAiUiModal.vue';
import { generateFlowHtml } from '../../services/workflow.service';
import { mapGetters } from 'vuex';
import { getDataApiVersion } from '../../utils/helpers';
import GeneralDropdown from '../core/general-dropdown.vue';
import DatabaseSchemaSelect from '../modals/databaseSchemaSelect.vue';

import PagePreviewModal from '@/components/modals/PagePreviewModal.vue';

export default {
  name: 'Start',
  data() {
    return {
      title: 'Title',
      description: 'eine Beschreibung ist',
      curlTemplate:
        'curl -X POST \\ -H "Accept: */*" \\ -H "Authorization: Bearer {{bearerToken}}" \\ -H "Connection: keep-alive" \\ -H "Content-Type: application/x-www-form-urlencoded" \\ -d "{{dataString}}" \\ {{url}}',
      selectedElement: {
        label: 'Text Bereich',
        type: '',
        value: '',
        attributes: {
          required: false,
        },
      },
      isFlowReferenceModalVisible: false,
      isAskAiUiModalVisible: false,
      isFlowAuthModalVisible: false,
      isPropsModalVisible: false,
      activeDropZone: null,
      loading: false,
      isAddElementVisible: false,
      databases: [],
      aiDropdownId: [],
      copyDatabaseSchemaIntoWorkflow: {
        showDatabaseSchemaModal: false,
        selectedSchema: null,
      },
      isPreviewLoading: false,
      formPreviewBlobURL: '',
    };
  },
  props: {
    flowRunnerEndpoint: {
      type: String,
    },
    flowId: Number,
    process: Object,
    settings: Object,
    task: Object,
    databaseSchema: [Array, Promise, Function],
    showDatabaseMissing: Boolean,
    isTableIdArray: Boolean,
    isUserHasAccess: { type: Boolean, default: true },
    isFileKeySelectModalVisible: { type: Boolean, default: false },
  },
  methods: {
    close: async function () {
      if (
        this.task.props.trigger == 'formTrigger' ||
        this.task.name == 'Form'
      ) {
        this.task.output = [];
        this.putElemetsInOutput().then(() => {
          if (this.task.name == 'Form')
            this.$set(
              this.task,
              'output',
              this.task.output.concat(this.task.input)
            );
          if (this.isFileKeySelectModalVisible) {
            this.loading = false;
          } else {
            this.loading = false;
            const styleElement = document.getElementById('aiUIStyles');
            if (styleElement) {
              document.head.removeChild(styleElement);
            }
            this.$emit('close');
          }
        });
      }
      if (this.settings && this.task.name != 'Form') this.addSettingsAsOutput();
    },
    drag: function (event) {
      event.dataTransfer.setData('selectedIdx', event.target.id);
    },
    dragover: function (event) {
      this.activeDropZone = event.target.id;
      event.preventDefault();
    },
    drop: function (event) {
      // Get relevant data from event
      var dropZone = event.target.classList[1];
      var selectedIdx = event.dataTransfer.getData('selectedIdx');
      var targetIdx = event.target.id;
      var selectedItem = this.task.props.formTrigger.elements[selectedIdx];

      // Handle new cols
      if (dropZone == 'vertical') {
        let tab = this.activeTab;
        let row = targetIdx;
        let path = this.formStructure['tabs'][tab]['rows'][row]['cols'];

        // Update the draged item
        selectedItem.structure.col = path.length;

        // Create new col
        this.$set(path, path.length, { id: path.length });
      } else {
        var selected = this.task.props.formTrigger.elements.splice(
          selectedIdx,
          1
        )[0];
        this.task.props.formTrigger.elements.splice(targetIdx, 0, selected);
        this.activeDropZone = null;
      }
    },
    putElemetsInOutput: async function () {
      this.loading = true;
      await Promise.all(
        this.task.props.formTrigger.elements.map(async (e) => {
          if (!this.getElementSettings(e, 'layoutItem')) {
            let el = {
              name: e.name,
              label: e.label,
              type: e.type,
              value: e.value,
            };
            switch (e.type) {
              case 'html':
              case 'resultwindow':
                break;

              // Transform input of type file to codelos file
              case 'file':
                try {
                  el.value = e.files[0];
                  this.task.output.push(el);
                } catch {}
                console.log('No File found');
                break;

              // Hidden type is always text
              case 'hidden':
                el.type = 'text';
                this.task.output.push(el);
                break;

              // Get model keys from database
              case 'model':
                // TODO: remove timeseries condition if all DB flows updated to loadprofile
                if (
                  this.process.dataType == 'timeseries' ||
                  this.process.dataType == 'loadprofile'
                )
                  el.type = el.label;
                else el.type = 'custom';
                el.value = await this.getFile(el.value);
                this.task.output.push(el);
                break;
              default:
                this.task.output.push(el);
                break;
            }
          }
        })
      );
    },
    addSettingsAsOutput: function () {
      // replace element if exists
      let indx = this.task.output.indexOf(
        this.task.output.filter((e) => e.isFromSettings)[0]
      );

      let e = {
        label: 'codelosSettings',
        name: 'codelosSettings',
        type: 'text',
        value: null,
        options: [],
        attributes: [],
        isFromSettings: true,
      };

      if (indx != -1) this.$set(this.task.output, indx, e);
      else this.$set(this.task.output, this.task.output.length, e);
    },
    setTrigger: function (Trigger) {
      this.task.props.trigger = Trigger;
    },
    showFlowReferenceModal: function () {
      if (!this.isUserHasAccess) return;
      this.isFlowReferenceModalVisible = true;
    },
    showAskAiUiModal() {
      if (this.isAskAiUiModalVisible) {
        this.isAskAiUiModalVisible = false;
      } else {
        this.isAskAiUiModalVisible = true;
      }
    },
    hideAskAiUiModal() {
      this.isAskAiUiModalVisible = false;
    },
    showFlowAuthModal: function () {
      this.isFlowAuthModalVisible = true;
    },
    hideFlowReferenceModal: function () {
      this.isFlowReferenceModalVisible = false;
    },
    hideFlowAuthModal: function () {
      this.isFlowAuthModalVisible = false;
    },
    saveFlowSettings: function () {
      this.isFlowReferenceModalVisible = false;
      this.isFlowAuthModalVisible = false;
    },
    async generateHtml(shouldShareStyle = false) {
      const { title, elements } = this.task.props.formTrigger;
      const formData = new FormData();

      formData.append('title', title);
      formData.append('id', this.flowId);
      formData.append('elements', JSON.stringify(elements));
      formData.append('settings', JSON.stringify(this.settings));
      if (shouldShareStyle && this.process.style)
        formData.append('style', JSON.stringify(this.process.style));
      if (this.settings.apiEndpoint) {
        formData.append('api_endpoint', this.settings.apiEndpoint);
      }
      return await generateFlowHtml(formData, this.getFormBuilderURl);
    },
    copyEmbedScript() {
      if (!this.isUserHasAccess) return;

      const apiEndpoint = this.settings.apiEndpoint
        ? this.settings.apiEndpoint
        : process.env.VUE_APP_FLOW_RUNNER_API;

      let html =
        '<!-- Codelos Inline-Widget Beginn -->\n<div' +
        ` id="codelos-inline-widget-${this.flowId}"` +
        '></div>\n<script' +
        ` id="codelos-inline-script-${this.flowId}" ` +
        'src="' +
        apiEndpoint +
        '/embed-script/' +
        this.flowId +
        '?include_id=true' +
        // ATTENTION: / (slash) in <\/script> end tags must be delimited using \ after each format of the document
        // eslint-disable-next-line no-useless-escape
        '"><\/script>\n<!-- Codelos Inline-Widget Ende -->';
      this.copyToClipboard(html);
      this.showToaster('Kopiert', 'Erfolgreich!', 'success');
    },
    createCURL() {
      if (!this.isUserHasAccess) return;

      let url = this.settings.apiEndpoint
        ? this.settings.apiEndpoint
        : process.env.VUE_APP_FLOW_RUNNER_API;
      url += '/run_flow_by_id';
      url += '?id=' + this.flowId;

      // Prepare cURL
      let cURL = this.curlTemplate
        .replace(
          '{{bearerToken}}',
          this.user.signInUserSession.accessToken.jwtToken
        )
        .replace('{{dataString}}', this.paramString)
        .replace('{{url}}', url);

      this.copyToClipboard(cURL);
      this.showToaster('Kopiert', 'Erfolgreich!', 'success');
    },
    async getFormAsHtmlFile() {
      if (!this.isUserHasAccess) return;
      const response = await this.generateHtml(true);

      if (response && response.status === 200 && response.data) {
        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.process.name + '.html';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    copyToClipboard: function (text) {
      var dummy = document.createElement('textarea');
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    },
    getFile: async function (key) {
      try {
        let url = process.env.VUE_APP_DATA_API;
        let tableName = this.process.tableID;

        if (this.isTableIdArray) {
          if (this.process.tableID.length > 0) {
            tableName = this.process.tableID[0];
          } else {
            tableName = undefined;
            this.setFileKeyModal();
            return;
          }
        }
        // TODO: remove timeseries condition if all flows updated to loadprofile
        if (this.isLoadProfileOrTimeseries) {
          const databaseName = key.split('/');
          if (
            databaseName.length &&
            databaseName[databaseName.length - 1].split('::').length &&
            databaseName[databaseName.length - 1].split('::')[0] === tableName
          ) {
            url +=
              '/files/' +
              encodeURIComponent(key) +
              '?use_pre_signed_s3_url=true';
          } else {
            this.setFileKeyModal();
            return;
          }
        } else {
          url = encodeURI(
            `${process.env.VUE_APP_DATA_API_BASE_URL}/${getDataApiVersion(
              tableName
            )}/user-tables/${tableName}/items/${encodeURIComponent(key)}`
          );
        }

        const myHeaders = new Headers();
        myHeaders.append(
          'Authorization',
          'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
        );

        if (tableName) {
          const response = await fetch(encodeURI(url), {
            method: 'GET',
            headers: myHeaders,
          });

          if (response.status === 401) {
            localStorage.clear();
            this.$router.push({
              name: 'auth',
              params: { message: 'Sitzung abgelaufen' },
            });
            return;
          } else if (response.status === 404 || response.status === 500) {
            this.setFileKeyModal();
            return false;
          }
          const json = await response.json();
          if (this.isLoadProfileOrTimeseries) {
            const res = await fetch(json['presigned-url']);
            if (res.status === 404 || res.status === 500) {
              this.setFileKeyModal();
              return false;
            }
            const loadCurve = await res.json();
            return loadCurve;
          } else {
            return json;
          }
        }
      } catch (error) {
        // Handle the error appropriately here
        if (error instanceof TypeError && error.message === 'Failed to fetch') {
          this.setFileKeyModal();
        }
        console.error('Error fetching file:', error);
      }
    },
    setFileKeyModal() {
      this.$emit('showFileKeySelectModal');
    },
    saveElements: function (elements) {
      this.task.props.formTrigger.elements = elements;
    },
    saveStructure: function (structure) {
      this.task.props.formTrigger.structure = structure;
    },
    isElementHasSettings(element) {
      return element.hasOwnProperty('settings');
    },
    getElementSettings(element, key) {
      if (this.isElementHasSettings(element)) {
        return element.settings.hasOwnProperty(key)
          ? element.settings[key]
          : null;
      } else {
        return element.hasOwnProperty(key) ? element[key] : null;
      }
    },
    addUiInUiElement(uiCssString, isAppend = false) {
      const uiElementIndex = this.task.props.formTrigger.elements.findIndex(
        (el) => el.name === 'automatedaicss'
      );
      if (uiElementIndex !== -1) {
        let uiStyleString =
          this.task.props.formTrigger.elements[uiElementIndex].value;
        if (isAppend) {
          uiStyleString = uiStyleString.slice(
            0,
            uiStyleString.indexOf('</style>')
          );

          uiStyleString += `${uiCssString}\n</style>`;
        } else {
          uiStyleString = `<style>\n${uiCssString}\n</style>`;
        }
        this.task.props.formTrigger.elements[uiElementIndex].value =
          uiStyleString;
      } else {
        const styleElement = {
          id: Math.round(Math.random() * 100000 + new Date().getTime()),

          options: [],
          structure: { tab: 0, row: 0, col: 0 },
          attributes: { required: true, disabled: false },
          name: 'automatedaicss',
          label: 'Automated AI CSS',
          placeholder: 'automatedaicss',
          type: 'automatedaicss',
          value: '',
          settings: {
            default: false,
            highlight: false,
            layoutItem: true,
          },
        };

        styleElement.value = `<style>\n${uiCssString}\n</style>`;
        this.task.props.formTrigger.elements.push(styleElement);
      }
    },
    addSelectedDatabase(database) {
      if (!this.isTableIdArray) {
        if (this.process.tableID != '') {
          this.process.tableID = [this.process.tableID, database];
        } else this.process.tableID = [database];
      }
      if (this.isTableIdArray) {
        this.process.tableID.push(database);
      }
    },
    removeAiCss() {
      const aiElemIndex = this.elements.findIndex(
        (element) => element.type === 'automatedaicss'
      );
      this.task.props.formTrigger.elements.splice(aiElemIndex, 1);
      document.querySelector('#automatedaicss')?.remove();
    },
    toggleAiDropdown(id) {
      if (this.aiDropdownId.includes(id)) {
        const index = this.aiDropdownId.indexOf(id);
        this.aiDropdownId.splice(index, 1);
      } else {
        this.aiDropdownId.push(id);
      }
    },
    toggleDatabaseSchemaModal(toggle = false) {
      if (!this.isUserHasAccess) return;
      this.copyDatabaseSchemaIntoWorkflow.showDatabaseSchemaModal = toggle;
    },
    addSchemaIntoWorkflow(schema) {
      const removeElements = [
        'databaselinkedview',
        'freecontent',
        'timestampms',
      ];
      const elementsNames = this.elements.map((element) => element.name);
      const elementsLables = this.elements.map((element) => element.label);

      const elements = [];
      for (const element of schema) {
        if (removeElements.includes(element.type)) {
          continue;
        }
        if (element.type === 'filenew') {
          element.name = 'file';
          element.type = 'file';
          element.value = '';
          element.label = 'File';
        }
        if (elementsNames.includes(element.name)) {
          const nameTailingNumbers = element.name.match(/\d+$/)
            ? parseInt(element.name.match(/\d+$/)[0])
            : 1;
          const labelTailingNumbers = element.label.match(/\d+$/)
            ? parseInt(element.label.match(/\d+$/)[0])
            : 1;
          element.name = this.createUniqueName(
            [...elementsNames, ...elements.map((element) => element.name)],
            element.name,
            nameTailingNumbers + 1
          );
          element.label = this.createUniqueName(
            [...elementsLables, ...elements.map((element) => element.label)],
            element.label,
            labelTailingNumbers + 1
          );
        }
        elements.push(element);
      }
      this.task.props.formTrigger.elements.push(...elements);
    },
    createUniqueName(names, name, num) {
      if (!names.includes(name)) {
        return name;
      } else {
        if (names.includes(name)) {
          name = name.replace(/[0-9]*$/, '');
          name += num;
        }
        return this.createUniqueName(names, name, ++num);
      }
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    async showFormPreview() {
      try {
        this.isPreviewLoading = true;
        const response = await this.generateHtml(true);
        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        });
        this.formPreviewBlobURL = URL.createObjectURL(blob);
      } catch (error) {
        this.isPreviewLoading = false;
        this.$emit('showToaster', 'Vorschau nicht möglich', 'Fehler', 'danger');
      }
    },
    onPreviewLoad() {
      this.isPreviewLoading = false;
    },
    toggleFormPreview(isVisible = false) {
      if (isVisible) {
        this.showFormPreview();
      } else {
        this.revokePageURL();
      }
    },
    revokePageURL() {
      if (this.formPreviewBlobURL) {
        URL.revokeObjectURL(this.formPreviewBlobURL);
        this.formPreviewBlobURL = null;
      }
    },
  },

  watch: {
    task: {
      deep: true,
      handler: function (value) {
        if (
          value.props.formTrigger.elements.find(
            (el) => el.name === 'automatedaicss'
          )
        ) {
          const aiUiStyleElement = JSON.parse(
            JSON.stringify(
              value.props.formTrigger.elements.find(
                (el) => el.name === 'automatedaicss'
              )
            )
          );

          let styleElement = document.getElementById('automatedaicss');
          if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = 'automatedaicss';
            document.head.appendChild(styleElement);
          }
          if (aiUiStyleElement.value) {
            aiUiStyleElement.value = aiUiStyleElement.value.replace(
              '<style>',
              ''
            );
            aiUiStyleElement.value = aiUiStyleElement.value.replace(
              '</style>',
              ''
            );
            styleElement.innerHTML = aiUiStyleElement.value;
          }
        }
      },
    },
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');

    // Show Database missing only for actions
    if (this.showDatabaseMissing) {
      this.$set(this.process, 'tableID', this.isTableIdArray ? [] : '');
      this.isFlowReferenceModalVisible = true;
    }
  },
  beforeDestroy() {
    this.revokePageURL();
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
      isAdmin: 'getIsAdmin',
    }),
    getFormBuilderURl() {
      if (
        this.settings &&
        this.settings.formBuilder &&
        this.settings.formBuilder !== null &&
        this.settings.formBuilder.trim() !== ''
      ) {
        return this.settings.formBuilder;
      } else {
        return 'v5';
      }
    },
    getformulaVersion() {
      const version = String(this.getFormBuilderURl || '').trim();
      const match = /^v(\d+)$/.exec(version);
      if (match) {
        return Number(match[1]);
      }
      return 6;
    },
    existingNames() {
      let names = this.task.props.formTrigger.elements.map((e) => e.name);
      names.push(this.settings.reference.label);
      return names;
    },
    user() {
      return this.$store.state.user;
    },
    paramString() {
      let paramString = '';

      this.task.props.formTrigger.elements.forEach((e) => {
        if (e.type != 'html') paramString += e.name + '=' + e.value + '&';
      });
      return paramString.slice(0, -1);
    },
    selectableTypes() {
      if (this.isAdmin)
        return this.typeList.filter((e) => e.visibility != 'hidden');
      return this.typeList.filter(
        (e) => e.visibility != 'hidden' && e.visibility != 'admin'
      );
    },
    activeTab() {
      return 0;
    },
    structure() {
      return this.task.props.formTrigger.structure;
    },
    elements() {
      return this.task.props.formTrigger.elements;
    },
    isLoadProfileOrTimeseries: function () {
      return (
        this.process.dataType === 'timeseries' ||
        this.process.dataType === 'loadprofile'
      );
    },
    getSelectedDbList() {
      let selectedDbArr = [];
      if (!this.isTableIdArray) {
        selectedDbArr.push(this.process.tableID);
      }

      if (this.isTableIdArray) {
        selectedDbArr = this.process.tableID;
      }

      const dbList = this.getCustomDatabases.filter((el) =>
        selectedDbArr.includes(el.name.trim())
      );

      return dbList;
    },
    getCustomDatabases() {
      const dType = this.process.dataType;
      if (dType == 'timeseries' || dType == 'loadprofile') {
        return this.databaseList.filter(
          (e) => e.type == this.process.dataType || e.type == 'loadprofile'
        );
      } else
        return this.databaseList.filter((e) => e.type == this.process.dataType);
    },
    getElementsToHide() {
      return ['linktodatabase', 'filenew', 'timestampms', 'smartmessage'];
    },
    isAiDropdownVisible() {
      return this.aiDropdownId.length !== 0;
    },
    getDropDownItems() {
      const dropDownItems = [
        {
          label: 'API Code (cURL) kopieren',
          icon: 'fas fa-plug',
          clickTrigger: () => this.createCURL(),
        },
        {
          label: 'Einbetten',
          icon: 'fas fa-code',
          clickTrigger: () => this.copyEmbedScript(),
        },
      ];
      if (this.isAdmin)
        dropDownItems.push({
          label: 'HTML Herunterladen',
          icon: 'fas fa-download',
          clickTrigger: () => this.getFormAsHtmlFile(),
        });
      return dropDownItems;
    },
  },
  components: {
    flowReferenceModal,
    flowAuthModal,
    fileKeySelect,
    FormBuilder,
    LoadingSpinner,
    askAiUiModal,
    GeneralDropdown,
    DatabaseSchemaSelect,
    PagePreviewModal,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.start-task-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
}

h1 {
  padding-top: 46px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 4px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  background: #f9f9fb;
  padding-top: 0px;
}

.tab.tab-form {
  min-height: 450px;
  background-color: #fff;
  height: 100%;
}

.tab.tab-time {
  height: 350px;
}

input,
select {
  font-family: 'Open Sans', open-sans, sans-serif;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  margin-right: 10px;
  margin-bottom: 15px;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: 300;
}

select {
  width: 70%;
}

.date {
  margin-top: 0;
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0px 0px 0px 10px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 134px;
  width: 95%;
  overflow: hidden;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
  cursor: pointer;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  height: 50px;
  overflow: hidden;
  margin-right: 15px;
  margin-top: 15px;
}
.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .form {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -893px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.icon {
  width: 30px;
  float: left;
  margin-right: 10px;
  margin-top: 6px;
}

.icon svg {
  fill: #959ba8;
}

.btn-default {
  background-color: #fff;
  color: #959ba8;
  text-align: center;
  border-color: rgb(214, 214, 221);
  line-height: 50px;
  cursor: pointer;
}

.tab.tab-form button {
  width: fit-content;
  padding-right: 19px;
  float: right;
  margin: 0 0 0 5px;
}

.tab.tab-form button.btn-green {
  padding-left: 20px;
}

.params {
  float: left;
  width: 30%;
}

.params > h2 {
  padding-top: 0;
  padding-bottom: 15px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #797c81;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 16px;
  text-transform: uppercase;
  text-align: left;
}

.modal.task .header {
  width: 100%;
}
.modal.task {
  padding: 60px 94px 40px 94px !important;
}

.modal.task .header .tools {
  float: right;
  height: 70px;
  width: auto;
  flex-direction: row;
  margin-top: 5px;
}

.modal.task .header .tools .item {
  display: inline-block;
  text-align: center;
  line-height: 61px;
  margin-left: 10px;
}

.modal.task .form-group .tools {
  height: 100%;
  left: 2px;
  top: 0;
  cursor: pointer;
  display: inline;
  width: 3%;
  opacity: 0;
  -webkit-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

.modal.task .form-group:hover .tools {
  opacity: 1;
}

.form-container {
  background: #fff;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100% - 72px);
}

.start-task-wrapper .form-container .initial-form {
  height: 100%;
}
/* .start-task-wrapper .form-container .initial-form .start-form-builder {
  height: calc(100% - 100px);
} */

.start-task-wrapper
  .form-container
  .initial-form
  ::v-deep
  .start-form-builder
  .content.flow-items-modal-scroll {
  height: 100%;
}

.start-task-wrapper
  .form-container
  .initial-form
  ::v-deep
  .start-form-builder
  .content.flow-items-modal-scroll
  .tab.tab-form {
  height: 100%;
}

.start-task-wrapper
  .form-container
  .initial-form
  ::v-deep
  .add-element-wrapper {
  max-height: calc(100vh - 420px) !important;
}

.start-task-wrapper .form-container .initial-form ::v-deep {
}

.form-header {
  display: block;
  height: 100px;
}

.form-settings {
  float: right;
  padding-right: 25px;
}

.form-settings i {
  font-size: 30px;
  padding-left: 15px;
  cursor: pointer;
}

.form-container input.title {
  z-index: 4;
  text-align: center;
  display: block;
  padding-bottom: 8px;
  font-size: 33px;
  color: #464d5d;
  margin: 5px 5px 5px 7px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  border: 0;
  height: 50px;
  float: left;
  width: 99%;
}

.form-container input.description {
  z-index: 4;
  text-align: center;
  border: 0;
  display: block;
  float: left;
  margin: 5px 5px 15px 7px;
  width: 99%;
  color: #888d9c;
}

.form-input {
  cursor: text;
}

.form-input.highlighted {
  background: #ff000024;
}

.form-container .tools {
  float: right;
  width: 32px;
  height: 30px;
  margin-top: -41px;
}
.form-container .tools i {
  font-size: 18px;
}
.form-container .edit-overlay {
  top: 0;
  width: 97%;
  height: 100%;
  -webkit-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
  cursor: unset;
  background: rgb(222 225 231 / 88%);
  opacity: 0;
  position: absolute;
  display: block;
  left: 0;
  border-radius: 6px;
  cursor: pointer;
}

.form-container .edit-overlay.large {
  height: 105%;
}

.form-container .edit-overlay:hover {
  opacity: 0.5;
}

.form-container .drop-zone {
  border: 5px solid #86c3f4;
}

.form-container .drop-zone.horizontal {
  width: 100%;
  height: 5px;
}

.form-container .drop-zone.vertical {
  float: right;
  display: inline-block;
  position: relative;
}

.add-button-wrapper {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 250px;
}

.add-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: #191f25;
  height: 60px;
  width: 60px;
  line-height: 55px;
  font-size: 32px;
  font-weight: 100;
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  -webkit-transition: -webkit-transform 0.2s ease-in-out;
  transition: -webkit-transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  background-size: 100%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.add-button:hover {
  transform: scale(1.1);
}

[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}
.modal.task .header .tools .item:hover:not([disabled]) {
  transform: scale(1.1) rotate(0);
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  background: #fff;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: 0 3px 3px 0;
  margin-top: 0;
  font-size: 35px;
  font-weight: 200;
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

button {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 17px;
  margin-bottom: 20px;
  margin-right: 30px;
}

.form-container form.codelos-app {
  width: 800px;
  text-align: left;
  min-height: 200px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.form-container form.codelos-app.full-width {
  width: 100%;
}

.form-container label {
  width: 80%;
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  padding-top: 0;
  padding-bottom: 6px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #464d5d;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
  padding-left: 12px;
}

.form-container input,
.form-container select {
  border-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  width: 95%;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 35px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 12px 11px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

form .form-group {
  width: 100%;
  height: 80px;
  margin-top: 0px;
  padding-top: 20px;
  padding-bottom: 1px;
  position: relative;
}

.form-group.large {
  height: 160px;
}

.radio-wrapper {
  width: 100%;
  display: block;
}

.radioOption {
  display: inline-block;
  width: fit-content;
  height: 40px;
  margin-right: 22px;
}

.radioOption input {
  float: none;
  width: 20px;
}

.radioOption label {
  line-height: 31px;
  float: right;
  padding: 0;
  margin-bottom: 0.3em;
  margin-right: 0;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: 12px;
  height: 31px;
}

.round-button {
  cursor: pointer;
  display: block;
  color: #1d1d1f;
  border-radius: 50%;
  background-color: white;
  height: 60px;
  width: 60px;
  text-align: center;
  line-height: 60px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  transition: transform 0.2s ease-in-out;
  font-size: 17px;
}

.footer {
  position: fixed;
  bottom: 21px;
}
.message {
  position: absolute;
  color: #54c08a;
  font-size: 16px;
  margin: 0;
  margin-top: 3px;
}

.loading-spinner {
  width: 100%;
  height: 100%;
  background-color: #ffff;
}

.loading-spinner.transparent {
  background-color: #9191912e;
}

.file-key-selector {
  position: absolute;
  top: 25%;
  left: 40%;
  background: white;
  z-index: 10;
  width: 200px;
  height: 300px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.drop-down {
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  -webkit-font-smoothing: unset;
  padding: 11px;
  border-radius: 9px;
  box-shadow: 0 2px 8px rgb(31 37 50 / 18%);
  bottom: 10px;
  position: relative;
  z-index: 100;
  width: 238px;
  list-style: none;
  background-color: #fff;
  overflow: scroll;
  height: 450px;
  border: none;
  top: -280px;
  margin-left: -271px;
}

.drop-down.add-element img {
  background-color: #fefbfb;
  vertical-align: middle;
  border-style: none;
  width: 50px;
  padding: 13px;
  margin: 4px;
  border-radius: 5px;
  border: 1px solid #d2d0d0;
}

.drop-down.add-element .item {
  padding: 5px;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
}

.drop-down.add-element .item:hover {
  background-color: #f1efef;
}

.col {
  max-width: 89%;
}
.workflow-model-scroll .modal.task,
.workflow-model-scroll .modal.task .form-container {
  overflow-y: hidden;
}
.start-task-wrapper .form-container .initial-form ::v-deep .form-tab {
  max-height: calc(100dvh - 520px);
  overflow-y: auto;
  overflow-x: hidden;
}
.start-task-wrapper ::v-deep .filter-dropdown .customDropdown {
  width: 89px;
}
.start-task-wrapper .extra-options-wrapper {
  display: flex;
  justify-items: center;
  align-items: center;
  gap: 10px;
}
.start-task-wrapper .round-button.options ::v-deep .dropdown {
  border-radius: 0.375rem;
  border-radius: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100% !important;
  height: 100% !important;
}

.start-task-wrapper .round-button.options ::v-deep .dropdown-toggle {
  width: 100% !important;
  height: 100% !important;
}
.start-task-wrapper .round-button.options ::v-deep .line-clamp {
  margin: 0 auto;
}
.start-task-wrapper .round-button.options:hover {
  transform: none !important;
}
.start-task-wrapper .daten-bank-schema img {
  width: 19px;
  height: 19px;
}

.start-task-wrapper .preview img {
  width: 27px;
  height: 27px;
}
.start-task-wrapper .preview ::v-deep a {
  text-indent: unset !important;
}
.start-task-wrapper .preview[disabled] a {
  pointer-events: none;
}
.start-task-wrapper .preview-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #ffffff;
  z-index: 12;
}

.start-task-wrapper .preview-wrapper .hide {
  visibility: hidden;
}

.start-task-wrapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 11;
}
</style>
